
































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import FlatButtonWithIcon from '@/components/FlatButtonWithIcon.vue'; // @ is an alias to /src
import FrameBox from '@/components/scanner/FrameBox.vue';
import DialogMobile from '@/components/scanner/DialogMobile.vue';
import Scanner from '@/components/scanner/Scanner.vue';
import MobileDetectionMixin from '@/assets/ts/mixins/MobileDetectionMixin';


@Component({
    components: {
        DialogMobile,
        Scanner,
        FrameBox,
        FlatButtonWithIcon,
    }
})
export default class Home extends Mixins(MobileDetectionMixin) {
    @Prop(Boolean) public showMobileScanner!: boolean;

    public mobileCameraHeight = 680;
    public mobileCameraWidth = 480;

    @Watch('innerWidth', { immediate: true, deep: true })
    private onInnerWidhtChanged(val: any, oldVal: any) {
      this.mobileCameraHeight = this.innerHeight;
      this.mobileCameraWidth = this.innerWidth;
    }

    get minHeightScanner(): number {
      if (this.mobileCameraHeight < 480) {
        return this.mobileCameraHeight;
      } else {
        return 480;
      }
    }

    get minWidthScanner(): number {
      if (this.mobileCameraWidth < 360) {
        return this.mobileCameraWidth;
      } else {
        return 360;
      }
    }
}
